import { Menu } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'underscore';
import Api from '../../../api/Api';
import { StoreContext } from '../../../store/store';
import { MenuListItem } from '../../../typings/menu';
import styles from '../Style/MenuList.module.scss';

const { SubMenu } = Menu;

export default function MenuList(props: {
  selectedKeys: string[];
  menuClick: (item: any) => void;
}) {
  const { menuList, menuCollapse, setMenuCollapse } = useContext(StoreContext);
  const [menuEle, setMenuEle] = useState<any | null>(null);

  useEffect(() => {
    const tempEle = menuList.map((m, idx) => {
      const hasChildren: boolean = !isEmpty(m.children);
      const isVip = (name: string) => name === 'Home';
      if (!hasChildren) {
        return (
          <Menu.Item
            key={m.id}
            className={isVip(m.label) ? styles.vipMenu : ''}
          >
            {m.pageId ? (
              <Link to={'/' + m.pageId}>{m.label}</Link>
            ) : (
              <a href={m.linkTo} target={m.target}>
                {m.label}
              </a>
            )}
          </Menu.Item>
        );
      }
      const childEle = m.children.map((child, childIdx) => {
        return (
          <Menu.Item key={child.id}>
            {child.pageId || !child.linkTo ? (
              child.label
            ) : (
              <a href={child.linkTo} target={child.target}>
                {child.label}
              </a>
            )}
          </Menu.Item>
        );
      });
      return (
        <SubMenu
          key={m.id}
          title={m.label}
          className={isVip(m.label) ? styles.vipMenu : ''}
        >
          {childEle}
        </SubMenu>
      );
    });

    setMenuEle(tempEle);
  }, [menuList]);

  return menuCollapse ? (
    <div className={styles.root}>
      <Menu
        defaultSelectedKeys={[]}
        defaultOpenKeys={[]}
        mode="inline"
        theme="dark"
        onClick={(item) => {
          setMenuCollapse(false);
          props.menuClick(item);
        }}
        selectedKeys={props.selectedKeys}
      >
        {menuEle}
      </Menu>
    </div>
  ) : null;
}

export function createMenuListData() {
  const menu: MenuListItem[] = [
    {
      id: '1',
      label: 'Home',
      linkTo: '/app',
      target: '_self',
      internal: false,
      active: false,
      children: [],
      pageId: 'app',
    },
    /*  {
      id: '2',
      label: 'Metocean Data Portal Version 1',
      linkTo: Api.VERSION1_URL,
      target: '_blank',
      internal: false,
      active: false,
      children: [],
    }, */
    {
      id: '2',
      label: 'About',
      linkTo: 'https://www.dhigroup.com/data-portals/metocean-data-portal',
      target: '_blank',
      internal: false,
      active: false,
      children: [],
    },
    {
      id: '3',
      label: 'Pricing',
      linkTo: 'https://www.metocean-on-demand.com/pricing',
      target: '_blank',
      internal: false,
      active: false,
      children: [],
      pageId: 'pricing',
    },
    {
      id: '4',
      label: 'Resources',
      linkTo: '',
      target: '',
      internal: false,
      active: false,
      children: [
        {
          id: '4-1',
          label: 'Videos',
          linkTo:
            'https://www.dhigroup.com/marine-water/metocean-data-portal?utm_source=portal&utm_medium=website&utm_campaign=GB-EN-PROM-MW-METDP#quick-tour',
          target: '_blank',
          internal: false,
          active: false,
          children: [],
        },
        {
          id: '4-2',
          label: 'API',
          linkTo:
            'https://apiv2.metocean-on-demand.com/APIHelp/#5-download-data',
          target: '_blank',
          internal: false,
          active: false,
          children: [],
        },
        // {
        //   id: '4-3',
        //   label: 'Terms of use',
        //   linkTo: 'https://www.dhigroup.com/terms-of-use',
        //   target: '_blank',
        //   internal: false,
        //   active: false,
        //   children: [],
        // },
        // {
        //   id: '4-4',
        //   label: 'Privacy policy',
        //   linkTo: 'https://www.dhigroup.com/privacy',
        //   target: '_blank',
        //   internal: false,
        //   active: false,
        //   children: [],
        // },
        // {
        //   id: '4-5',
        //   label: 'Cookie policy',
        //   linkTo: 'https://www.dhigroup.com/cookie-page',
        //   target: '_blank',
        //   internal: false,
        //   active: false,
        //   children: [],
        // },
      ] as MenuListItem[],
    },
    // {
    //   id: '5',
    //   label: 'Portals',
    //   linkTo: '',
    //   target: '',
    //   internal: false,
    //   active: false,
    //   children: [
    //     {
    //       id: '5-1',
    //       label: 'Forecast',
    //       linkTo: 'https://app.waterforecast.com/metocean',
    //       target: '_blank',
    //       internal: false,
    //       active: false,
    //       children: [],
    //     },
    //     {
    //       id: '5-2',
    //       label: 'Bathymetry',
    //       linkTo: 'https://bathymetrics.shop/#/mappage',
    //       target: '_blank',
    //       internal: false,
    //       active: false,
    //       children: [],
    //     },
    //     {
    //       id: '5-3',
    //       label: 'Altimetry',
    //       linkTo: 'https://altimetrypro.z6.web.core.windows.net/',
    //       target: '_blank',
    //       internal: false,
    //       active: false,
    //       children: [],
    //     },
    //     {
    //       id: '5-4',
    //       label: 'Global Seas (beta)',
    //       linkTo: 'https://globalseasdev.z6.web.core.windows.net/',
    //       target: '_blank',
    //       internal: false,
    //       active: false,
    //       children: [],
    //     },
    //   ],
    // },
    {
      id: '6',
      label: 'Contact',
      linkTo: 'https://www.metocean-on-demand.com/contact',
      target: '_blank',
      internal: false,
      active: false,
      children: [],
      pageId: 'contact',
    },
  ];

  return menu;
}
